/*
 * my-location.js
 * Remembers the visitor's chosen location (localStorage) and keeps every
 * element carrying a data-mloc-* hook in sync, on every page.
 *
 * Hooks (put them on any element, e.g. in the header or a product page):
 *   data-mloc-name   -> location name
 *   data-mloc-phone  -> phone number (text + tel: href when an <a>)
 *   data-mloc-book   -> Book Now href
 *   data-mloc-link   -> location page href
 *   data-mloc-show   -> element is visible only when a location is chosen
 *   data-mloc-hide   -> element is hidden once a location is chosen
 *
 * Whatever the server rendered inside the element is the fallback shown
 * when no location is chosen.
 *
 * API: MyLocation.get(), .set({id,name,phone,book,url,address}), .clear(),
 *      .onChange(fn)
 */
(function () {
  if (window.MyLocation) return;

  var KEY = "mylocation:v1";
  var subs = [];

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function put(v) {
    try {
      if (v) localStorage.setItem(KEY, JSON.stringify(v));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }
  function tel(p) { return "tel:" + String(p || "").replace(/[^\d+]/g, ""); }
  function each(sel, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), fn);
  }
  function keep(el) {
    if (!el._mloc) el._mloc = { text: el.textContent, href: el.getAttribute("href"), label: el.getAttribute("aria-label") };
    return el._mloc;
  }
  function setHref(el, value, fallback) {
    var v = value || fallback;
    if (v) el.setAttribute("href", v); else el.removeAttribute("href");
  }

  function apply() {
    var l = get();

    each("[data-mloc-name]", function (el) {
      var f = keep(el);
      el.textContent = l ? l.name : f.text;
    });
    each("[data-mloc-phone]", function (el) {
      var f = keep(el);
      el.textContent = l && l.phone ? l.phone : f.text;
      if (l && l.phone) el.setAttribute("href", tel(l.phone));
      else setHref(el, null, f.href);
      el.hidden = !el.textContent.trim();
    });
    each("[data-mloc-book]", function (el) {
      var f = keep(el);
      setHref(el, l && l.book, f.href);
      // Accessible name always starts with the visible text ("Book Now ...")
      var base = (f.text || "").trim() || "Book Now";
      if (l) el.setAttribute("aria-label", base + " at " + l.name);
      else if (f.label) el.setAttribute("aria-label", f.label);
      else el.removeAttribute("aria-label");
    });
    each("[data-mloc-link]", function (el) {
      var f = keep(el);
      setHref(el, l && l.url, f.href);
    });
    each("[data-mloc-show]", function (el) { el.hidden = !l; });
    each("[data-mloc-hide]", function (el) { el.hidden = !!l; });

    document.documentElement.setAttribute("data-my-location", l ? l.id : "");
  }

  function notify() {
    var l = get();
    subs.forEach(function (fn) { try { fn(l); } catch (e) {} });
  }

  window.MyLocation = {
    get: get,
    set: function (l) { put(l); apply(); notify(); },
    clear: function () { put(null); apply(); notify(); },
    onChange: function (fn) { subs.push(fn); }
  };

  // Other tabs
  window.addEventListener("storage", function (e) {
    if (e.key === KEY) { apply(); notify(); }
  });
  // Theme editor re-renders sections
  document.addEventListener("shopify:section:load", apply);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", apply);
  else apply();
})();